import { RawClientConfiguration } from "@common/configuration/adapt-client-configuration";
import { clientConfiguration as baseClientConfiguration } from "@common/configuration/environment.base";

export const clientConfiguration: Partial<RawClientConfiguration> = Object.assign({}, baseClientConfiguration, {
    AdaptProjectName: "Cumulus",
    SentryDsn: "https://1b3347462ed24f0b98a867b853d38b4d@sentry.io/210226",
} as Partial<RawClientConfiguration>);
